import React from 'react';
import PDFIcon from '../components/icons/PDFIcon';
import Tooltip from 'antd/es/tooltip';
import { isNullOrUndefined } from '../utils';
import { useTranslation } from '@nic-react-i18n/core';

/*
enum STATUS {
    loading,
    ready,
    base,
    error,
}
*/
interface PDFLoaderInterface {
    type: string;
    version: string;
    showText?: boolean;
    enableOnClick?: boolean;
    enabledIcon?: React.ReactElement<any>;
    disabledIcon?: React.ReactElement<any>;
}

type PDFLoaderProps = PDFLoaderInterface

const docConf = 'DocumentConfiguration';

interface IconInterface {
    selected: boolean;
    enabledIcon?: React.ReactElement<any>;
    disabledIcon?: React.ReactElement<any>;
}
interface DocRefInterface extends React.PropsWithChildren{
    url: string;
    documentName: string;
}
export const DocRef: React.FC<IconInterface & DocRefInterface> = (props) => {
    let  component = !props.selected ? (
        <button>
            {props.children}
        </button>
    ) : (
        <a href={props.url} target={'_blank'} rel="noreferrer" download={props.documentName}>
            {props.children}
        </a>
    );
    return (
        <span>{component}</span>
    );
};

export const Icon: React.FC<IconInterface> = (props) => {
    const {enabledIcon, disabledIcon} = props;

    let enabled = (!isNullOrUndefined(enabledIcon) ? enabledIcon : <PDFIcon color={'green'}/>);
    let disabled = (!isNullOrUndefined(disabledIcon) ? disabledIcon : <PDFIcon color={'red'}/>);
    let component =
        (props.selected ? enabled : disabled);
    return (
        <span>{component}</span>
    );
};

const PDFLoader: React.FC<PDFLoaderProps> = (props) => {
    const [url] = React.useState('#')
    //const [status, setStatus] = React.useState(STATUS.base)

    const {t, locale} = useTranslation()
/*
    changeStatus = (data: Blob) => {
        // console.log('fetched: ');

    }
*/
    const getDocumentTitle = () => {
        const { version, type, } = props;

        let docs = (window as any)[docConf];
        let documentTitle = docs[type][locale];
        return `${documentTitle}${version}.pdf`;
    }

    // Se la componennte ha specificato la proprietà enableOnClick allora il caricamento
    // del documento avviene in due passaggi (due click): il primo click trasforma il link
    // scarica il documento e trasforma il link con href che riferisce un blob contente
    // il file PDF. Il secondo click permette di visualizzare il documento.
/*
    clickHandler = () => {
        const {enableOnClick} = this.props;

        if (enableOnClick) {
            let documentTitle = this.getDocumentTitle();
            // this.setState({status: STATUS.loading});
            fetch(`/documents/${documentTitle}`)
                .then(r => r.blob())
                .then(data => {
                    this.setState({url: URL.createObjectURL(data)});
                })
                .catch(err => {
                    console.log('Error: ', err);
                    this.setState({status: STATUS.error});
                });
        }
    }
*/
    // Se la componennte non ha specificato la proprietà enableOnClick allora il caricamento
    // del documento avviene mediante quando la componente è 'momtata'.
    // Il link ha già href che riferisce un blob contenente il file pdf e quindi è necessario
    // un unico click per visualizzare il documento.
/*
    componentDidMount() {
        const { enableOnClick } = this.props;

        if (!enableOnClick) {
            let documentTitle = this.getDocumentTitle();

            fetch(`/documents/${documentTitle}`)
                .then(r => r.blob())
                .then(data => {
                    // console.log('fetched: ');
                    this.setState({url: URL.createObjectURL(data)});
                })
                .catch(err => {
                    console.log('Error: ', err);
                });
        }
    }
*/

        const {showText, enabledIcon, disabledIcon} = props;

        let selected: boolean = (url !== '#');

        let selectedString = (selected ? 'selected' : 'unselected');
        let tooltipTitle: string = t(`tooltip.document.${selectedString}`);

        return (

          <div
              style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '10%'
              }}
          >
              <Tooltip
                  title={tooltipTitle}
              >
                  <a
                      href={`/documents/${getDocumentTitle()}`}
                      rel="noreferrer"
                      target={'_blank'}
                  >
                      <Icon
                          selected={true}
                          enabledIcon={enabledIcon}
                          disabledIcon={disabledIcon}
                      />
                  </a>
                  {/*
                  <div
                      onClick={this.clickHandler}
                  >
                    <DocRef url={url} selected={selected} documentName={this.getDocumentTitle()}>
                        <Icon
                            selected={selected}
                            enabledIcon={enabledIcon}
                            disabledIcon={disabledIcon}
                        />
                    </DocRef>
                  </div>
                  */}
              </Tooltip>
              {showText && <span style={{fontSize: '1rem'}}>{getDocumentTitle()}</span>}
          </div>
        );

}

export default PDFLoader;